<template>
  <ui-select
    key="text-or"
    ref="tagsSelect"
    v-model="tags"
    :search-input="searchTags"
    :class="[
      'tag-search__input',
      'tag-search__input--combobox',
    ]"
    prepend-inner-icon="fas fa-search"
    :items="tags"
    :multiple="true"
    item-text="name"
    chips
    :combobox="true"
    button-style="text"
    :placeholder="t('Search')"
    :hide-details="1"
    :menuProps="{
      nudgeTop: 0,
    }"
    @blur="$emit('handleInputBlur', $event)"
    @focus="$emit('handleInputFocus', $event)"
    @change="$emit('handleTagsChange', $event)"
  >
    <template #append>
      <tag-search-append
        :has-clear="!!(isShowClear || hasClear)"
        :has-marks="hasMarks"
        :hide-tags="hideTags"
        :selected="switchSearchMode"
        @update:selected="$emit('update:switchSearchMode', $event)"
        @clear="$emit('handleClear', $event)"
      ></tag-search-append>
    </template>
  </ui-select>
</template>

<script setup lang="ts">
import TagSearchAppend from '@/views/reports/pickers/tag-search-append.vue';
import { useI18n } from '@/composables';

defineProps<{
  hideTags?: boolean;
  isShowClear?: boolean;
  hasClear?: boolean;
  hasMarks?: boolean;
  searchTags?: string;
  switchSearchMode?: string;
}>();

defineEmits<{
  'update:switchSearchMode': [value: string];
  handleInputBlur: [event: FocusEvent];
  handleInputFocus: [event: FocusEvent];
  handleTagsChange: [value: unknown];
  handleClear: [event: unknown];
}>();

const tags = defineModel<any>();

const { t } = useI18n();
</script>

<style lang="scss">

</style>
